<template>
  <div id="order-customers">
    <!-- Content -->
    <CRow>
      <CCol sm="12">
        <CCard>
          <CCardHeader class="d-flex justify-content-between align-items-center">
            <h4 class="mb-0">
              Clientes - Ordernar
            </h4>
            <CCol
              sm="5"
              class="pr-0 pl-0 d-flex align-items-center"
            >
              <label
                class="mb-0 mr-3"
                for="stepFilter"
                style="flex-basis: 100px"
              >Filtrar</label>
              <Multiselect
                id="stepFilter"
                v-model="exhibition_style"
                :options="exhibitionOptions"
                :multiple="false"
                placeholder="Selecione um tipo de exibição"
                track-by="value"
                label="label"
                :searchable="true"
                :required="false"
                :show-pointer="false"
                :disabled="processing"
              >
              </Multiselect>
            </CCol>
          </CCardHeader>

          <CCardBody>
            <!-- Sortable -->
            <CRow>
              <CCol col="12">
                <Sortable
                  :items="datatable.items"
                  :fields="datatable.fields"
                  :enable-switch-status="false"
                  :enable-export="false"
                  @endDragging="endDragging"
                >
                </Sortable>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import Sortable from '@/components/ui/Sortable'
import { orderBy, debounce } from 'lodash'
import CustomerService from '@/services/customer.service'
import Multiselect from '@/components/ui/Multiselect'

export default {
  metaInfo: {
    title: 'Clientes',
    titleTemplate: ' %s - Manager - OW Interactive'
  },

  components: {
    Sortable,
    Multiselect
  },

  data () {
    return {
      datatable: {
        items: [],
        fields: [
          {
            key: 'status',
            label: 'Status',
            sorter: false,
            _style: 'width: 8%;'
          },
          {
            key: 'title',
            label: 'Cliente',
            sorter: false,
            thumb: true
          }
        ]
      },
      query: {
        search: '',
        page: 1,
        perpage: localStorage.getItem('perPageItem') ? parseFloat(localStorage.getItem('perPageItem')) : 10,
        pagination: false,
        status: true,
        sorter: {
          asc: false,
          column: ''
        }
      },
      processing: false,
      exhibitionOptions: [
        {
          label: 'Todos',
          value: ''
        },
        {
          label: 'Não exibir',
          value: 'nao-exibir'
        },
        {
          label: 'Normal',
          value: 'normal'
        },
        {
          label: 'Destaque',
          value: 'destaque'
        }
      ],
      exhibition_style: {
        label: 'Todos',
        value: ''
      }
    }
  },

  watch: {
    exhibition_style: {
      handler:
        'updateDataTable'
    }
  },

  async created () {
    await this.updateDataTable()
  },

  methods: {
    async updateDataTable () {
      const queryData = this.query
      queryData.exhibition_style = this.exhibition_style.value

      const response = await CustomerService.getAll(queryData)
      if (response) {
        const newItems = response.map(item => {
          return {
            ...item,
            thumb: item.logo.length > 0 ? item.logo[0].url : null,
            status: item.status === 1
          }
        })

        this.datatable.items = orderBy(newItems, ['order'])
      }
    },

    endDragging: debounce(function (items) {
      this.datatable.items = items
      CustomerService.updateCustomerOrders(this.datatable.items)

      this.$notify({
        group: 'notifications',
        type: 'success',
        text: 'Ordenação alterada com sucesso.'
      })
    }, 1000)
  }
}
</script>

<style lang="scss">
#order-customers {
  .orderButton {
    margin-right: 10px;
  }

  .thumb {
    width: 80px !important;
    margin-left: -13px !important;
    background-color: black !important;
  }
}

</style>
